import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ClipboardCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageHeader, EmptyState, PageLoading } from "@/components/shared";
import { ComplianceBadge } from "@/components/ComplianceBadge";
import { RenewalGuidance } from "@/components/RenewalGuidance";
import api from "@/lib/api";

export default function Renewals() {
  const { t } = useTranslation();
  const [emps, setEmps] = useState(null);
  const [company, setCompany] = useState(null);
  const [openId, setOpenId] = useState(null);

  useEffect(() => {
    api.get("/employer/employees").then((r) => setEmps(r.data.employees.filter((e) => ["ACTION_REQUIRED", "CRITICAL"].includes(e.compliance_status))));
    api.get("/employer/company").then((r) => setCompany(r.data.company));
  }, []);

  if (emps === null) return <><PageHeader title={t("guide.renewalsTitle")} /><PageLoading /></>;

  return (
    <div data-testid="renewals-page">
      <PageHeader title={t("guide.renewalsTitle")} subtitle={t("guide.renewalsSub")} />
      {emps.length === 0 ? (
        <EmptyState icon={ClipboardCheck} title={t("guide.renewalsEmpty")} testid="renewals-empty" />
      ) : (
        <div className="space-y-4">
          {emps.map((e) => {
            const d = e.permit_days_remaining;
            const open = openId === e.id;
            return (
              <div key={e.id} className="card-soft p-4" data-testid={`renewal-row-${e.id}`}>
                <div className="flex flex-wrap items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-navy to-cyan-dark text-sm font-bold text-white">{e.first_name[0]}{e.last_name[0]}</span>
                  <div className="min-w-0">
                    <Link to={`/app/employer/employees/${e.id}`} className="text-sm font-semibold text-navy hover:underline">{e.first_name} {e.last_name}</Link>
                    <div className="text-xs text-slate-400">{e.nationality || "—"} · {e.job_title || "—"}</div>
                  </div>
                  <div className="ml-auto flex items-center gap-3">
                    <span className="text-xs text-slate-500">{d != null ? (d < 0 ? t("guide.expired") : t("guide.daysLeft", { n: d })) : ""}</span>
                    <ComplianceBadge status={e.compliance_status} />
                    <Button size="sm" variant="outline" className="rounded-full text-xs" onClick={() => setOpenId(open ? null : e.id)} data-testid={`toggle-guide-${e.id}`}>
                      {open ? t("guide.hideGuide") : t("guide.viewGuide")}
                    </Button>
                  </div>
                </div>
                {open && <div className="mt-4"><RenewalGuidance emp={e} company={company} /></div>}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
